import { createSlice } from "@reduxjs/toolkit";

const initialorganizationRegionalState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: [],
  organizationRegionalForEdit: undefined,
  lastError: null
};

export const callTypes = {
  list: "list",
  action: "action"
};

export const superAdminOrganizationRegionalSlice = createSlice({
  name: "organizationRegional",
  initialState: initialorganizationRegionalState,
  reducers: {
    catchError: (state, action) => {
      state.listLoading = false;
      state.actionsLoading = false;
      // state.error = `${action.type}: ${action.payload.error}`;
      // if (action.payload.callType === callTypes.list) {
      //   state.listLoading = false;
      // } else {
      //   state.actionsLoading = false;
      // }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },

    // getorganizationRegionalById
    organizationRegionalFetched: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.organizationRegionalForEdit = action.payload.data;
    },
    // findorganizationRegional
    organizationRegionalsFetched: (state, action) => {
      const { total_items, items } = action.payload;
      state.actionsLoading = false;
      state.listLoading = false;
      state.error = null;
      state.entities = items;
      state.totalCount = total_items;
    },
    // Set to default state actionLoading & error
    organizationRegionalReload: (state, action) => {
      state.actionsLoading = false;
      state.listLoading = false;
      state.error = null;
    },
    organizationRegionalFiles: (state, action) => {
      state.organizationRegionalFiles = action.payload.items;
      state.totalCount = action.payload.total_items;
      state.listLoading = false;
      state.actionsLoading = false;
    },
    organizationRegionalFilesFetched: (state, action) => {
      state.organizationRegionalFiles = action.payload.items;
      state.listLoading = false;
      state.actionsLoading = false;
    }
  }
});
